//购物车
export const ADD_PRODUCT = 'ADD_PRODUCT'; //添加商品
export const REDUCE_PRODUCT = 'REDUCE_PRODUCT'; //减少商品数量
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT'; //移除商品
export const CLEAR_PRODUCT  = 'CLEAR_PRODUCT'; //清空购物车
export const MODIFY_PRODUCT = 'MODIFY_PRODUCT'; //修改购物车商品数量
export const RESTORE_SHOPCART = 'RESTORE_SHOPCART'; //还原购物车数据

//计划清单
export const PLAN_LIST_ADD_PRODUCT = 'PLAN_LIST_ADD_PRODUCT'; //添加商品
export const PLAN_LIST_REDUCE_PRODUCT = 'PLAN_LIST_REDUCE_PRODUCT'; //减少商品数量
export const PLAN_LIST_REMOVE_PRODUCT = 'PLAN_LIST_REMOVE_PRODUCT'; //移除商品
export const PLAN_LIST_CLEAR_PRODUCT  = 'PLAN_LIST_CLEAR_PRODUCT'; //清空计划清单
export const PLAN_LIST_MODIFY_PRODUCT = 'PLAN_LIST_MODIFY_PRODUCT'; //修改计划清单商品数量
export const RESTORE_PLAN_LIST = 'RESTORE_PLAN_LIST'; //还原计划清单数据

// 切换中英文
export const MODIFY_LOCALE_LANGUAGE= 'MODIFY_LOCALE_LANGUAGE'; //切换中英文

